// @flow
import * as React from 'react'
import CreateElement from 'util/CreateElement'

import './Text.module.scss'

export const ALIGN = {
  inherit: 'inherit',
  center: 'center',
  left: 'left',
  right: 'right',
}

export type Align = $Keys<typeof ALIGN>

export const COLOR = {
  black: 'black',
  gray: 'gray',
  yellow: 'yellow',
  blue: 'blue',
  green: 'green',
  orange: 'orange',
  red: 'red',
  white: 'white',
  inherit: 'inherit',
}

export type Color = $Keys<typeof COLOR>

export const LINE_HEIGHT = {
  inherit: 'inherit',
  normal: 'normal',
  heading: 'heading',
}

export type LineHeight = $Keys<typeof LINE_HEIGHT>

export const SIZE = {
  inherit: 'inherit',
  ten: 'ten',
  thirteen: 'thirteen',
  fifteen: 'fifteen',
  eighteen: 'eighteen',
  twentyTwo: 'twentyTwo',
  twentyFour: 'twentyFour',
  thirtyTwo: 'thirtyTwo',
  forty: 'forty',
}

export type Size = $Keys<typeof SIZE>

export const TRANSFORM = {
  none: 'none',
  uppercase: 'uppercase',
  lowercase: 'lowercase',
  capitalize: 'capitalize',
}

export type Transform = $Keys<typeof TRANSFORM>

type Props = {
  component: string,
  inline: boolean,
  bold: boolean,
  italic: boolean,
  uppercase: boolean,
  color?: Color,
  align?: Align,
  lineHeight?: LineHeight,
  transform?: Transform,
  size?: Size,
  sizeDesktop?: Size,
  children: React.Node,
}

export default class Text extends React.Component<Props> {
  static defaultProps = {
    component: 'div',
    inline: false,
    bold: false,
    italic: false,
    uppercase: false,
  }

  render = () => {
    const styleName = [
      'text',
      `textInline-${this.props.inline.toString()}`,
      `textBold-${this.props.bold.toString()}`,
      `textItalic-${this.props.italic.toString()}`,
      `textUppercase-${this.props.uppercase.toString()}`,
      this.props.color ? `textColor-${this.props.color}` : '',
      this.props.align ? `textAlign-${this.props.align}` : '',
      this.props.lineHeight ? `textLineHeight-${this.props.lineHeight}` : '',
      this.props.transform ? `textTransform-${this.props.transform}` : '',
      this.props.size ? `textSize-${this.props.size}` : '',
      this.props.sizeDesktop ? `textSizeDesktop-${this.props.sizeDesktop}` : '',
    ].join(' ')

    return (
      <CreateElement component={this.props.component} styleName={styleName}>
        {this.props.children}
      </CreateElement>
    )
  }
}
